import styled from 'styled-components';

/** A small two-way choice (point-cloud colours, height mode): the active option is green. */
export const Pick = styled.div`
	display: inline-flex;
	border: 1px solid ${({ theme }) => theme.colors.border};
	border-radius: 5px;
	overflow: hidden;
	font-size: 0.78rem;
	button {
		border: 0;
		background: transparent;
		color: ${({ theme }) => theme.colors.textColor};
		padding: 1px 8px;
		cursor: pointer;
		&.on {
			background: ${({ theme }) => theme.colors.green};
			color: #fff;
		}
		&:disabled {
			opacity: 0.45;
			cursor: not-allowed;
		}
	}
`;
